import axios from 'axios';

export interface CreateSharedLinkRequest {
  sharedToken: string;
}

export interface CreateSharedLinkResponse {
  sharedLink: string;
}

export interface ResolveSharedLinkRequest {
  sharedKey: string;
}

export interface ResolveSharedLinkResponse {
  path: string;
  params: Record<string, unknown> | null;
}

const CACHE_KEY_PREFIX = 'sharedLink_';

export default {
  async create(form: CreateSharedLinkRequest): Promise<CreateSharedLinkResponse> {
    const cacheKey = `${CACHE_KEY_PREFIX}${form.sharedToken}`;
    const cached = sessionStorage.getItem(cacheKey);

    if (cached) {
      return JSON.parse(cached) as CreateSharedLinkResponse;
    }

    const res = await axios.post<CreateSharedLinkResponse>('/SharedLink/create', form);
    sessionStorage.setItem(cacheKey, JSON.stringify(res.data));
    return res.data;
  },

  async resolve(form: ResolveSharedLinkRequest): Promise<ResolveSharedLinkResponse> {
    const res = await axios.post<ResolveSharedLinkResponse>('/SharedLink/resolve', form);
    return res.data;
  },
};
